import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13acdafd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container comment" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col commentContentArea" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "commentUserInfo" }
const _hoisted_6 = { class: "creationDate" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = {
  key: 1,
  class: "row"
}
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_avatar_component = _resolveComponent("user-avatar-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_user_avatar_component, {
        avatarURL: _ctx.comment.userAvatarUrl,
        userLevel: _ctx.comment.userLevel,
        id: "userAvatar"
      }, null, 8, ["avatarURL", "userLevel"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: "username",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickProfile && _ctx.clickProfile(...args)))
            }, _toDisplayString(_ctx.comment.username), 1),
            _createTextVNode(),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.creationString), 1)
          ])
        ]),
        (_ctx.comment.text != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.comment.text), 1))
          : _createCommentVNode("", true),
        (_ctx.comment.mediaUrl != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("img", {
                src: _ctx.gifLink,
                class: "gifWrapper"
              }, null, 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}